import { WebItem } from 'src/app/App';
import isFacetOptionsPresentInNavigationData from '../../../../components/left-faceted-grid/adapters/flex-facets-adapter/style-facet-options-checker/check-facet-options-in-navigation-data';
import { FacetData, FacetOption } from '../types';
export const combineFacetReportStrings = (
  combined: string[],
  facetReportStrings: string[]
): string[] => combined.concat(...facetReportStrings);

export const condenseSortByFacets = (allFacets: {
  [property: string]: FacetOption[];
}) => {
  allFacets.sortBy = allFacets.sortBy || [];
  allFacets.sortByField?.map(({ id, direction }, idx) => {
    const sortByDir =
      direction?.id ||
      (allFacets.sortByDir[idx] && allFacets.sortByDir[idx].id);
    allFacets.sortBy.push({
      facetType: 'sortBy',
      tagDisplayLabel: `${id},${sortByDir}`,
    });
  });
};

const qfPrefix = (appliedQuickFacets: string[], id: string) =>
  appliedQuickFacets?.includes(id) ? 'QF_' : '';

export const buildFacetReportString =
  (
    allFacets: {
      [property: string]: FacetOption[];
    },
    appliedQuickFacets: string[]
  ) =>
  (facetType: string | number) =>
    allFacets[facetType].map(
      ({ id, name, tagDisplayLabel, searchFacetOptionId }) => {
        return `${facetType}=${qfPrefix(appliedQuickFacets, id)}${
          tagDisplayLabel || name || searchFacetOptionId
        }`;
      }
    );

export const facetEngagementAdapter = (
  facetData: FacetData | undefined | null | '',
  appliedQuickFacets: string[]
) => {
  if (!facetData) {
    return '';
  }

  const { appliedFacets, facetSelected } = facetData;

  const facets = appliedFacets || facetSelected;
  const facetsCopy = JSON.parse(JSON.stringify(facets));
  condenseSortByFacets(facetsCopy);

  return Object.keys(facetsCopy)
    .filter(
      (facetType) =>
        ['storeId', 'sortByField', 'sortByDir'].indexOf(facetType) < 0
    )
    .map(buildFacetReportString(facetsCopy, appliedQuickFacets))
    .reduce(combineFacetReportStrings, [])
    .join(' | ');
};

const shouldShowStyle = (styleFacetData, webHierarchy, selectedNodes) => {
  if (styleFacetData && styleFacetData.options) {
    return isFacetOptionsPresentInNavigationData(
      styleFacetData,
      webHierarchy,
      selectedNodes
    );
  }
  return false;
};

export const dynamicFacetNameEnabled = (
  facetData: FacetData,
  webHierarchy: WebItem[],
  selectedNodes: Array<{ type: string; name: string }>,
  isDynamicStyleFacetNameEnabled: boolean
) => {
  if (!facetData) {
    return undefined;
  }
  const styleFacetData = facetData.facetOptions.find(
    (facet) => facet.name?.trim() === 'style'
  );
  return shouldShowStyle(styleFacetData, webHierarchy, selectedNodes)
    ? isDynamicStyleFacetNameEnabled
    : undefined;
};
